import { Formik, Form } from 'formik'
import cn from 'classnames'

import { InputField } from '@components/forms/InputField'
import { Button } from '@components/Buttons'
import { MultiSelectField } from '@components/forms/MultiSelectField'
import { SelectField } from '@components/forms/SelectField'
import { initialValues as defaultValues } from '@constants/form/campaign/initialValues'
import { AdvanceIcon } from '@components/icons/AdvanceIcon'
import { SearchIcon } from '@components/icons/SearchIcon'
import { CampaignSearchFormProps } from './interface'

export function CampaignSearchForm({
  initialValues,
  showAdvanceSearch,
  bookType,
  categories,
  penNameOptions,
  handleSubmit,
  handleAdvanceSearchChange,
}: CampaignSearchFormProps) {
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      enableReinitialize
    >
      {({ resetForm, isSubmitting }) => (
        <Form>
          <div className='grid gap-y-[20px]'>
            <div
              className={cn(
                'flex desktop-tablet:space-x-[20px] mobile:gap-y-[20px] mobile:grid'
              )}
            >
              <InputField
                name='searchText'
                placeholder='ค้นหางานเขียน, นามปากกา'
                inputClassName='font-light bg-gray-1 text-secondary-1 rounded-[20px] border-none'
                className='flex-1'
                leftIcon={
                  <SearchIcon className=' text-primary w-[20px] h-[20px]' />
                }
              />
              <Button
                type='button'
                onClick={handleAdvanceSearchChange}
                className={cn('border w-max mobile:w-full', {
                  'bg-secondary dark:bg-purple text-white dark:text-white-2 dark:border-purple':
                    !showAdvanceSearch,
                  'bg-white dark:bg-dark-7 text-sencondary dark:text-dark-10 dark:border-dark-10':
                    showAdvanceSearch,
                })}
                icon={
                  <AdvanceIcon
                    className={cn({
                      'text-white dark:text-white-2': !showAdvanceSearch,
                      'text-secondary dark:text-dark-10': showAdvanceSearch,
                    })}
                  />
                }
              >
                <span className='text-[14px] font-medium'>การค้นหาขั้นสูง</span>
              </Button>
            </div>
            {showAdvanceSearch && (
              <div className='flex desktop-tablet:items-center mobile:flex-col'>
                <div className='grid grid-cols-3 mobile:grid-cols-1  gap-[20px] flex-1 mobile:mb-[20px]'>
                  <SelectField
                    name='bookType'
                    options={bookType}
                    placeholder='ลักษณะงานเขียน'
                    label='ลักษณะงานเขียน'
                  />
                  <MultiSelectField
                    name='categoryIds'
                    label='หมวดหมู่'
                    placeholder='หมวดหมู่'
                    options={categories}
                  />
                  <MultiSelectField
                    name='penNameIds'
                    label='นามปากกา'
                    placeholder='นามปากกา'
                    options={penNameOptions}
                  />
                </div>
                <div className='flex items-center justify-end ml-[25px]'>
                  <Button
                    type='button'
                    className='text-secondary dark:text-dark-10 underline'
                    onClick={() => {
                      resetForm({ values: defaultValues })
                      handleSubmit(defaultValues)
                    }}
                  >
                    <span className='text-[14px] font-medium'>ล้างค่า</span>
                  </Button>
                  <Button
                    type='submit'
                    disabled={isSubmitting}
                    className='bg-primary dark:bg-purple text-white dark:text-white-2'
                  >
                    <span className='text-[14px]'>ค้นหา</span>
                  </Button>
                </div>
              </div>
            )}
          </div>
        </Form>
      )}
    </Formik>
  )
}
